import { SkillResourceSteps } from '../models/Timeline';

export const getTimelineButtonLabel = (option: SkillResourceSteps) => {
  if (option === SkillResourceSteps.WORKED_EXAMPLE) return 'Get started!';
  if (option === SkillResourceSteps.PRACTICE_PROBLEMS) return 'Start practice';
  if (option === SkillResourceSteps.SKILL_CHALLENGE) return 'Take Challenge';
};

export const getTimelineButtonType = (option: SkillResourceSteps) => {
  if (option === SkillResourceSteps.WORKED_EXAMPLE) return false;
  if (option === SkillResourceSteps.PRACTICE_PROBLEMS) return false;
  if (option === SkillResourceSteps.SKILL_CHALLENGE) return true;
};
